// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"P8-z"};